import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";

import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";

// import PersonIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/People.svg"
import PeopleIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/People.svg";
import SinglePerson from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/SinglePerson.svg";
import CalendarIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/Calendar.svg";
import BookIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/Book.svg";
import DashboardOverviewCard from "../../../../components/PagesComponents/Organizational/Management/Dashboard/OverviewCard.components";
import AttendanceGraph from "../../../../components/PagesComponents/Operational/Academic/Dashboard/AttendanceGraph.component";
import ScrollableShortCard from "../../../../components/Universal/ScrollableShortCard.component";
import ScrollableShortCardComponentCard from "../../../../components/PagesComponents/Operational/Academic/Dashboard/ScrollableShortCardComponentCard.component";
import CardHeader from "../../../../components/Universal/CardHeader.component";
import DonutChart from "../../../../components/Universal/DonutChart.component";
import ScrollableCardTable from "../../../../components/Universal/ScrollableCardTable.component";
import SelectFilter from "../../../../components/PagesComponents/UniversalComponents/SelectFilter.component";
import IndivisualMemberCard from "../../../../components/PagesComponents/Organizational/Management/Members/IndivisualMemberCard.component";
import TableCard from "../../../../components/Universal/TableCard.component";
import { Helmet } from "react-helmet";

const OverviewCardTitleToIcon = {
  Students: SinglePerson,
  Teachers: PeopleIcon,
  "Today's Events": CalendarIcon,
  "Rest of the books": BookIcon,
};

const Body = ({
  classesFilter,
  setClassesFilter,
  genderWaysFilter,
  setGenderWaysFilter,
  overViewCardData,
  attendanceData,
  lineChartFilter,
  setLineChartFilter,
  absenteesData,
  onleaveData,
  classWiseAttendanceData,
  bestPerformers,
}) => {
  return (
    <section className="w-full flex-col align-start justify-start g-1">
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <PageHeader
        renderCustomElement={
          <div
            className="flex-row align-center justify-start g-05"
            style={{ flexWrap: "wrap" }}
          >
            <TogglePushBtn
              type="radio"
              setVal={(val) => setGenderWaysFilter(val)}
              name="examreportToggle"
              value={genderWaysFilter}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) => setGenderWaysFilter(val)}
              name="examreportToggle"
              value={genderWaysFilter}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) => setGenderWaysFilter(val)}
              name="examreportToggle"
              value={genderWaysFilter}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />
          </div>
        }
      />

      {/* dashboard overview cards  */}
      <div className="flex-row align-center  justify-start g-1">
        {overViewCardData &&
          overViewCardData.map((data, index) => {
            const { title, presentCount, cardType = "regular", bgColor } = data; // Destructure cardType
            const IconComponent = OverviewCardTitleToIcon[title];

            return (
              <DashboardOverviewCard
                key={index}
                icon={cardType === "regular" ? IconComponent : null} // Condition for icon
                cardType={cardType} // Pass cardType prop
                title={title}
                presentCount={presentCount}
                bgColor={bgColor}
              />
            );
          })}
      </div>

      {/* main body grid type structures  */}
      <div className="flex-row align-start justify-start g-1">
        {/* left side container */}
        <div className="w-half flex-col align-start justify-start g-1">
          {/* left top overview graph */}
          <AttendanceGraph
            graphData={attendanceData}
            graphTitle="Student attendance"
            graphFilter={(val) => setLineChartFilter(val)}
          />

          <div
            className="flex-row align-start justify-start g-1"
            style={{ height: "55vh" }}
          >
            <div className="w-half  radius-6 p-1 back-white">
              <ScrollableShortCard
                title="Absentees"
                actionBtn={
                  <div>
                    <span className="color-greenColor t-12">
                      {absenteesData.length} students
                    </span>
                  </div>
                }
              >
                {absenteesData &&
                  absenteesData?.map((data) => {
                    return (
                      <ScrollableShortCardComponentCard
                        name={data.name}
                        date={data.date}
                        studentClass={data.class}
                        image={data.image}
                        _id={data.id}
                      />
                    );
                  })}
              </ScrollableShortCard>
            </div>
            <div className="w-half  p-1 radius-6 back-white">
              <ScrollableShortCard
                title="On Leave"
                actionBtn={
                  <div>
                    <span className="color-greenColor t-12">
                      {onleaveData?.length} persons
                    </span>
                  </div>
                }
              >
                {onleaveData &&
                  onleaveData?.map((data) => {
                    return (
                      <ScrollableShortCardComponentCard
                        name={data.name}
                        date={data.date}
                        studentClass={data.designation}
                        image={data.image}
                        _id={data.id}
                      />
                    );
                  })}
              </ScrollableShortCard>
            </div>
          </div>
        </div>
        {/* right side parent container */}
        <div className="w-half flex-col align-start justify-start g-1">
          {/* right top, class wise attendance chart */}
          <div
            className="w-full  back-white p-1 radius-6 flex-col align-start justify-start g-1"
            // style={{ height: "45vh" }}
          >
            <CardHeader
              title="Class wise attendance"
              actionBtn={<SelectFilter />}
              headerStyle={{ borderBottom: "none" }}
            />
            <div className="flex-row g-05 space-between w-full h-half flex-1">
              <div className="h-full w-half">
                <DonutChart
                  data={classWiseAttendanceData}
                  valuemapKey={"count"}
                />
              </div>

              <div className="w-half h-full flex-col align-start justify-start">
                <ScrollableCardTable thead={["Classes", "Count", "%"]}>
                  {classWiseAttendanceData &&
                    classWiseAttendanceData?.map((_data, index) => {
                      return (
                        <tr
                          key={index}
                          style={{
                            "--pollingDonutChartTableDetailsIndicatorColor":
                              _data.color,
                          }}
                          className="pollingDetailsTableData w-full flex-row align-center justify-arround"
                        >
                          <td
                            style={{
                              width: `calc(100%/${3})`,
                              textAlign: "center",
                            }}
                          >
                            {_data.class}
                          </td>
                          <td
                            style={{
                              width: `calc(100%/${3})`,
                              textAlign: "center",
                            }}
                          >
                            {_data.count}
                          </td>
                          <td
                            style={{
                              width: `calc(100%/${3})`,
                              textAlign: "center",
                            }}
                          >
                            {_data.percentage}%
                          </td>
                        </tr>
                      );
                    })}
                </ScrollableCardTable>
              </div>
            </div>
          </div>
          <div
            className=" back-white p-2 radius-6 flex-col align-start justify-start g-1"
            style={{ height: "64vh" }}
          >
            <div className="w-full h-full">
              <TableCard
                tableHead={["Student name", "Class", "Total Points"]}
                title={"Best performer of the day (each class)"}
              >
                {bestPerformers &&
                  bestPerformers?.map((data, index) => (
                    <IndivisualMemberCard
                      key={data.id}
                      image={data.image}
                      name={data.name}
                      profileId={data.studentId}
                      designation={data.class}
                      percentage={data.points}
                    />
                  ))}
              </TableCard>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
